import {defHttp, otherHttp} from '/@/utils/http/axios';
import {getMenuListResultModel} from './model/menuModel';

enum Api {
    GetMenuList = '/getMenuList',
    // 左侧菜单
    GET_LEFT_MENUS = '/v1/main/get_menus.do',
    // 头部菜单菜单
    // GET_TOP_MENUS = '/v1/module/headMenus',
    GET_TOP_MENUS = '/__common/auth/get_app_menus.do',
}

/**
 * @description: Get user menu based on id--MOCK
 */
export const getMenuList = () => {
    return defHttp.get<getMenuListResultModel>({url: Api.GetMenuList});
};

/**
 * @description: Get user menu based on id--AJAX
 */
//  export const getLestMenuList = (params) =>
//  otherHttp.get({
//    url: Api.GET_MENUS_SEARCH,
//    params,
//  });
export const getLeftMenuList = (params) =>
    otherHttp.get({
        url: Api.GET_LEFT_MENUS,
        params
    });


export const getTopMenuList = () =>
    otherHttp.get({
        url: Api.GET_TOP_MENUS
    });
